/* 
 * @author Tommy Brière
 * @copyright (c) 2015 Groupe PVP
 * @fileoverview TODO
 */
(function($g, storage) {
    "use strict";    
    var Signal = $g.Signal;
    var MUTED_STORAGE_KEY = "musicPlayer.muted";
    var tri = $g.try;
    var TIMEOUT = 10 * 1000;
    var RETRY_ERROR = 20 * 1000;
    var INIT_TIMEOUT = 2 * 1000;

    var storage;
    
    tri(function() {
        storage = window.localStorage;
    });
    function time() {
        return new Date().getTime();
    }    
    
    function MusicPlayer(audio, loader, musics) {
        var LOADING = {
            name: "LOADING",
            time: function() {
                if (audio.muted) {
                    //Play but is muted, treat as error
                    setEtat(ERROR);
                    muted=true;
                    audio.pause();
                } else {
                    setEtat(PLAYING);
                    next(); 
                    update();
                }
                onInitComplete.trigger();
            },
            error: function() {
                setEtat(ERROR);
                muted=true;
                audio.pause();
                onInitComplete.trigger();
            },
            timeout: function() {
                $g.log("timeout sur play " + musics[playIndex]); 
                setEtat(ERROR);
                muted=true;
                audio.pause();
                onInitComplete.trigger();
            }
        };
        var LOADED = {
            name: "LOADED",
            play: function() {
                audio.play();
                setEtat(PLAYING);
                update();
            }
        };
        var ERROR = {
            name: "ERROR",
            //Erreur, limiter les retry
            play: function() {
                var now = time();
                if (now > retryTime) {
                    retryTime = now + RETRY_ERROR;
                    playNextMusic();
                }
            },
            /*time: function() {
                if (audio.muted) {
                } else {
                    setEtat(IDLE);
                }
                onInitComplete.trigger();
            }*/
        };
        var PLAYING = {
            name: "PLAYING",
            error: function() {
                setEtat(ERROR);
                muted=true;
            },
            ended: playNextMusic,
            pause: function() {
                audio.pause();
                setEtat(LOADED);
                update();
            },
            play: function() {
                if (audio.paused && !fixed) {
                    fixed = true;
                    $g.logToSrv("MusicPlayer.PLAYING:player audio seem stuck, fixing..."); 
                    audio.play();
                }
                if (audio.currentTime > musicLastTime || !musicLastTime) {
                    musicLastTime = audio.currentTime;
                    musicStuck = 0;
                } else {
                    //are we stuck ?
                    musicStuck++;
                    if (musicStuck === 10) {
                        $g.logToSrv("MusicPlayer.PLAYING audio seem stuck no fix implemented here")
                    }
                }
            }            
        };
        var IDLE = {
            name: "IDLE",
            play: playNextMusic
        };
        
        //var me = this;
        var playing;
        var muted=false;
        var fixed=false;
        
        var nextMusic = 0;
        var playIndex = -1;
        var loading = -1;
        var retryTime = time();
        
        var etats=[];
        var etat;
        var timeout;
        var musicLastTime;
        var musicStuck = 0;
        var onInitComplete = new Signal();
        
        function loadNextMusic() {
            var mus = musics[nextMusic];
            if (mus&&!etats[nextMusic]) {
                loading=nextMusic;
                loader.src = mus;
                etats[nextMusic] = LOADING;
            }
        }

        function setEtat(nextEtat) {
            $g.logToSrv("MusicPlayer.setEtat", etat ? etat.name : "", nextEtat.name);
            etat = nextEtat;
            
        }
                
        function next() {
            nextMusic=(nextMusic+1)%musics.length;            
            loadNextMusic();
        }
        
        function regTimeout(time) {
            clearTimeout(timeout);
            timeout=setTimeout(function() {
                event("timeout");
            }, time);            
        }
        
        function playNextMusic() {
            if (musics && musics.length > 0) {
                fixed = false;//reset fixed flag
                if (etats[nextMusic] === ERROR) {
                    next();
                }
                var mus = musics[nextMusic];
                playIndex=nextMusic;
                audio.src = mus;
                audio.play();
                setEtat(LOADING);
                regTimeout(TIMEOUT);
            }
        }

        function testAudioCap() {
            if (musics && musics.length > 0) {
                fixed = false;//reset fixed flag
                var mus = musics[0];
                audio.src = mus;
                var p = audio.play();
                setEtat(LOADING);
                regTimeout(INIT_TIMEOUT);
                if (p) {
                    p.catch(function() {
                        $g.warning("blocage détecté");
                        event("error");
                    });
                }
            }
        }
        
        function audioEnded() {
            event("ended");
        }
        
        function audioError(err) {
            $g.warning("impossible de jouer musique " + musics[playIndex], err); 
            event("error");
        }
        
        function audioTime() {
            event("time");
        }
        
        function loaderCanplay() {
            etats[loading] = LOADED;
        }
                
        function loaderError() {
            etats[loading] = ERROR;
            $g.warning("impossible de charger musique " + musics[loading]);            
            /*playNextMusic();*/
        }
        
        function attachEvents() {
            audio.addEventListener("timeupdate", audioTime);//play
            audio.addEventListener("play", audioTime);//play
            audio.addEventListener("ended", audioEnded);
            audio.addEventListener("error", audioError);
            
            loader.addEventListener("canplay", loaderCanplay);
            loader.addEventListener("error", loaderError);
        }
        
        function removeEvents() {
            audio.removeEventListener("timeupdate", audioTime);
            audio.removeEventListener("play", audioTime);//play
            audio.removeEventListener("ended", audioEnded);
            audio.removeEventListener("error", audioError);
            loader.removeEventListener("canplay", loaderCanplay);
            loader.removeEventListener("error", loaderError);            
        }
        
        function event(evt) {
            var f = etat[evt];
            if (f) {
                f();
            }
        }
        
        function update() {
            var shouldPlay = playing && !muted;
            if (shouldPlay) {
                event("play");
                //playNextMusic();
            } else {
                event("pause");
            }
        }
        
        /**
         * load the next music to play
         * @returns {undefined}
         */
        this.load = function() {
            loadNextMusic();
        };
        
        /**
         * play the current music
         * @returns {undefined}
         */
        this.play = function() {
            playing=true;
            update();
        };
        
        this.stop = function() {
            playing=false;
            update();
        };
                
        Object.defineProperty(this, "playing", {
            get: function() {
                return playing;
            },
            set: function(value) {
                playing = value;
                update();
            }
        });
        Object.defineProperty(this, "muted", {
            get: function() {
                return muted;
            },
            set: function(value) {
                muted = value;
                update();
                if (storage) {
                    tri(function() {                   
                        if (value) {
                            storage.setItem(MUTED_STORAGE_KEY, "t"); 
                        } else {
                            storage.removeItem(MUTED_STORAGE_KEY);
                        }
                    });
                }
            }
        });
        Object.defineProperty(this, "musics", {
            get: function() {
                return musics;
            },
            set: function(value) {
                if (JSON.stringify(musics)!==JSON.stringify(value)) {
                    musics = value;
                    loading = -1;
                    playIndex = -1;
                    nextMusic = 0;
                    etats = [];
                    playNextMusic();
                }
            }
        });
        this.unmuteNoSave = function() {
            muted = false;
        };
        this.muteNoSave = function() {
            muted = true;
        };
              
        this.init = function(complete) {
            if (complete) {
                onInitComplete.once(complete);
            }
            readMuted();
            
            audio.preload="auto";
            audio.autoplay=true;   
            loader.autoplay=false;
            loader.preload="auto";
            
            attachEvents();
            
            setEtat(IDLE);    
            testAudioCap();            
        };

        /**
         * Restauration du fonctionnement après un click de souris
         * Pour les systèmes qui ont besoin d'un click
         */
        this.clicked = function() {
            readMuted();
            this.play();
        };
        
        this.destroy = function() {
            if (audio) {
                removeEvents();
                audio.pause();                
                audio=null;
            }
            if (loader) {
                loader.pause();
                loader=null;
            }
            clearTimeout(timeout);
            timeout=null;
        };
        
        function readMuted() {            
            if (storage) {
                tri(function() {
                    muted = storage.getItem(MUTED_STORAGE_KEY);  
                });
            }
        }
                
    }
    
    $g.MusicPlayer = MusicPlayer;
    
})(PVPGEngine);